import React from 'react';
import { Button } from '../ui/button';

const LABELS = {
  sent: ['Sent (accepted by mail server)', 'text-emerald-600'],
  skipped: ['Skipped', 'text-amber-600'],
  pending: ['Queued', 'text-muted-foreground'],
  sending: ['Sending', 'text-muted-foreground'],
  retry_scheduled: ['Retrying', 'text-amber-600'],
  failed: ['Failed: needs attention', 'text-rose-600'],
  uncertain: ['Delivery uncertain', 'text-orange-600'],
};

const fmt = (iso) => (iso ? new Date(iso + 'Z').toLocaleString() : '');

export const NotificationHistoryRow = ({ entry: h, onRetry, busy }) => {
  const [label, color] = LABELS[h.status] || [h.status, 'text-muted-foreground'];
  return (
    <div className="flex flex-wrap items-center gap-2 rounded border px-2 py-1 text-xs" data-testid={`po-notification-history-${h.id}`}>
      <span className={`font-medium ${color}`} data-testid={`po-notification-status-${h.id}`}>{label}</span>
      <span>{h.event_key === 'po_receipt' ? 'Receipt' : 'Fully received'}</span>
      <span className="text-muted-foreground">{fmt(h.created_at)}</span>
      {h.status === 'retry_scheduled' && h.next_attempt_at && (
        <span className="text-muted-foreground">next try {fmt(h.next_attempt_at)}</span>
      )}
      {h.attempts > 0 && <span className="text-muted-foreground">attempt {h.attempts} of {h.max_attempts || 6}</span>}
      {h.reason && <span className="font-mono text-muted-foreground break-all">{h.reason}</span>}
      {h.to && <span className="text-muted-foreground">to: {h.to}</span>}
      {h.can_retry && (
        <Button type="button" size="sm" variant="outline" className="ml-auto h-6 px-2 text-xs" disabled={busy}
          onClick={() => onRetry(h)} data-testid={`po-notification-retry-${h.id}`}>
          {busy ? 'Retrying…' : 'Retry'}
        </Button>
      )}
    </div>
  );
};
